<template>
  <div :class="['product-gallery', imagesLenght == 1 ? 'single-mode' : '']">
    <!--«««Галерея миниатюр-->
    <swiper
        @swiper="setThumbsSwiper"
        :navigation="{
          prevEl: '#ts-arr-prev',
          nextEl: '#ts-arr-next',
        }"
        :centerInsufficientSlides="true"
        :slides-per-view="5"
        :space-between="6"
        :freeMode="true"
        :watchSlidesVisibility="true"
        :breakpoints="thumbsOptions.breakpoints"
        class="product-gallery__thumbs"
    >
      <swiper-slide v-for="image in images" :key="image.id"
                    class="thumbs-swiper__slide">
        <img :src='`${img_url}${image.path}`' alt="" class="thumbs-swiper__thumb">
      </swiper-slide>
    </swiper>
    <!--Галерея миниатюр»»»-->

    <!--«««Основная фотогалерея-->
    <swiper
        :navigation="{
          prevEl: '#ts-arr-prev',
          nextEl: '#ts-arr-next',
        }"
        :thumbs="{ swiper: thumbsSwiper }"
        @swiper="setMainSwiper"
        class="product-gallery__main">
      <swiper-slide v-for="(image, index) in images" :key="image.id"
                    @click="showPopup"
                    :data-index="index"
                    class="large-photos-swiper__slide">
        <img :src='`${img_url}${image.path}`' alt="" class="large-photos-swiper__photo">
      </swiper-slide>

    </swiper>
    <!--Основная фотогалерея»»»-->

    <!--«««Кнопки-->
    <div v-if="true" class="swiper-dir-control-button thumbs-swiper__arrow ts-arr-prev" id="ts-arr-prev">
      <svg class="swiper-dir-control-button__icon prev" preserveAspectRatio="none" width="14" height="32"
           viewBox="0 0 14 32" xmlns="http://www.w3.org/2000/svg">
        <path d="m14 31h-9l-5-15 5-15h9l-5 15zm-7.6-2h4.8l-4.3-13 4.3-13h-4.8l-4.3 13z">
        </path>
      </svg>
    </div>
    <div v-if="true" class="swiper-dir-control-button thumbs-swiper__arrow ts-arr-next" id="ts-arr-next">
      <svg class="swiper-dir-control-button__icon next" preserveAspectRatio="none" width="14" height="32"
           viewBox="0 0 14 32" xmlns="http://www.w3.org/2000/svg">
        <path d="m9 31h-9l5-15-5-15h9l5 15zm-6.2-2h4.8l4.3-13-4.3-13h-4.8l4.3 13z"></path>
      </svg>
    </div>
    <!--Кнопки»»»-->
  </div>
</template>

<script>
// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

// import Swiper core and required modules
import SwiperCore, {
  Navigation, Thumbs
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default {
  name: "ProductGallery",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      thumbsSwiper: null,
      thumbsOptions: {
        breakpoints: {
          1024: {
            direction: 'vertical',
            slidesPerView: 6
          },
          760: {
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 10
          }
        }
      },
    };
  },
  computed: {
    images() {
      return this.$store.getters['product/GET_IMAGES']
    },
    imagesLenght() {
      return this.$store.getters['product/GET_IMAGES_LENGTH']
    },
  },
  mounted() {
    this.ppJs.swipers.product_card_main = null
    this.ppJs.swipers.product_card_thumbs = null
  },
  methods: {
    showPopup(event) {

      let windowWidth = window.innerWidth;
      let index = event.target.closest('.large-photos-swiper__slide').dataset.index;
      if (windowWidth > 760) {
        let galleryBg = document.querySelector('.product-popup-gallery-color-overlayer');
        // всплывающая фотогалерея в карточке товара
        let popupGallery = document.querySelector('.product-popup-gallery');
        this.ppJs.general.main.style.zIndex = '10';
        galleryBg.style.display = 'block';
        popupGallery.style.display = 'block';
        // popupThumbs.update();
        this.ppJs.swipers.product_card_popup_main.update();
        this.ppJs.swipers.product_card_popup_thumbs.update();
        this.ppJs.swipers.product_card_popup_main.slideTo(parseInt(index), 0,false);
        this.ppJs.swipers.product_card_popup_thumbs.slideTo(parseInt(index), 0,false);
        // popupThumbs.slideTo(index - 1, 0, true);
        document.body.style.overflow = 'hidden';
      }

      console.log(index)
    },
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper
      // swiper.navigation.prevEl = document.getElementById("ts-arr-prev")
      // swiper.navigation.nextEl = document.getElementById("ts-arr-next")
      swiper.$wrapperEl.addClass("thumbs-swiper")
    },
    setMainSwiper(swiper) {
      // swiper.thumbs.swiper = this.thumbsSwiper
      // swiper.navigation.prevEl = document.getElementById("ts-arr-prev")
      // swiper.navigation.nextEl = document.getElementById("ts-arr-next")
      // swiper.thumbs.multipleActiveThumbs = false
      swiper.$wrapperEl.addClass("large-photos-swiper")
      this.ppJs.swipers.product_card_main = swiper
    },
  },
}
</script>

<style scoped>

</style>